module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "characters"
    }
  }, [_c('h1', [_vm._v("Characters")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Lord Armando")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Sister Helewise")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Duke of Landburg")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Duchess Bella")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Roseabella: Oldest daughter")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Eder: Son of Duke and Duchess")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Ardelean: Middle daughter of Duke and Duchess")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Gretta: Youngest daughter of Duke and Duchess")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Josiah: Son of Roseabella and Armando")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Soneia and Armanda: twin daughters of Roseabella and Armando")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Gerrold: Armando’s top man")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Meiga: Wife of Gerrold")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Saige: Granddaughter of Gerrold and Meiga")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Father Strickland: Priest")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Marga and Ragga: Twin slayers")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Romane: Ship crew")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Captain Morgan: Captain of the ship (who is in love with Helewise)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("2 puppies bought in a port for supply run, on Armando’s ship, they grow huge and are trained as fighting dogs.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Garrett: Cousin of Armando and Helewise who turns Vampire.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Morgania: Vampire woman")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Hatmanu: Slave to the Vampires")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Rueband: Boy on Garrett’s ship")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Bacia: Garrett’s top man")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Manu: was whipped and fed to the sharks for attacking Rueband and Gretta")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Dr. Bardue: Doctor on Garrett’s ship")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0